export const contactBar = () => {

	const contactBar = document.querySelector(".contact-control");

	if (!contactBar)
	{
		return;
	}

	const asideContacts = document.querySelectorAll(".post__aside-visitcards .visitcard");
	let intersectingElementsObserver = null;


	const getLastAsideContactshowContactBar = () =>
	{
		let bottom = -1;
		let lowestElement = null;
		asideContacts.forEach((element) =>
		{
			const rect = element.getBoundingClientRect();

			if (rect.bottom >= bottom)
			{
				bottom = rect.bottom;
				lowestElement = element;
			}
		});

		// lowestElement.style.backgroundColor = "red";


		return lowestElement;
	}

	const showContactBar = () =>
	{
		contactBar.classList.add("contact-control--active");
	}

	const hideContactBar = () =>
	{
		contactBar.classList.remove("contact-control--active");
	}

	const observeAsideContacts = () =>
	{
		intersectingElementsObserver = new IntersectionObserver((entries) =>
		{
			entries.forEach((entry) =>
			{
				if (entry.isIntersecting)
				{
					hideContactBar();
				}
				else
				{
					showContactBar();
				}
			});
		},
		{
			// This rootMargin creates a horizontal line vertically centered
			// that will help trigger an intersection at that the very point.
			// Callback will get called as soon as the element's most top or
			// most bottom edge intersects with the center of the viewport.
			// rootMargin: "-50% 0% -50% 0%",

			// threshold - percent of element visible part
			threshold: 0.5
		});


		//start observing the elements
		intersectingElementsObserver.observe(lastAsideContact);
	};


	if (!asideContacts)
	{
		showContactBar();
		return;
	}

	const lastAsideContact = getLastAsideContactshowContactBar();

	if (!lastAsideContact)
	{
		showContactBar();
		return;
	}

	observeAsideContacts();
};
